const reviews = [
	{
		id: 541671, // Example ID for 'The Whale' (movie) - Make sure this matches an actual movie you can click
		mediaType: 'movie',
		title: 'Ballerina (2025)',
		rating: '4.5/5',
		reviewDate: '2023-01-25',
		poster_path: '/oKk6D6Pj6x5w9u4e9wFhP7G6X6S.jpg',
		reviews: [
			{
				reviewer: 'Fools Dream',
				rating: '4.5/5',
				reviewDate: '2023-01-25',
				reviewText: `
			Darren Aronofsky's "The Whale" is an incredibly difficult, yet profoundly moving, cinematic experience.
			Brendan Fraser delivers an absolutely career-defining performance as Charlie, a morbidly obese
			college professor trying to reconnect with his estranged daughter. His portrayal is heartbreakingly
			vulnerable and authentic, completely transforming himself both physically and emotionally.
		`,
			},
			{
				reviewer: 'Trajor',
				rating: '4.5/5',
				reviewDate: '2023-01-25',
				reviewText: `
			The film is essentially a chamber piece, mostly taking place within Charlie's apartment, which
			intensifies the claustrophobic feeling and focuses all attention on the powerful performances.
			While some critics have debated its portrayal of obesity, the film undeniably explores themes of
			grief, regret, and the desperate search for redemption with unflinching honesty. It's not an easy
			watch, but it's a powerful one that lingers long after the credits roll. Highly recommend for the
			performances, especially Fraser's, but be prepared for its emotional weight.
		`,
			}
		],
	},
	{
		id: 846422, // Example ID for 'The Last of Us' (TV show) - Make sure this matches an actual TV show
		mediaType: 'tv',
		title: 'The Last of Us (Season 1)',
		rating: '5/5',
		reviewDate: '2023-03-19',
		poster_path: '/qNVQ9L5I4w1QzXnQe1Uf0B0m62w.jpg',
		reviewText: `
			HBO's "The Last of Us" is a masterclass in adaptation, translating the beloved video game's
			narrative, characters, and emotional core to the screen with stunning fidelity and depth.
			Pedro Pascal and Bella Ramsey are perfectly cast as Joel and Ellie, bringing a palpable
			chemistry and nuance to their evolving relationship amidst a brutal, post-apocalyptic world.

			What sets this series apart is its willingness to expand upon the game's lore, offering
			meaningful divergences and enriching the backstories of secondary characters (Episode 3 is
			a standout). The production design is gritty and realistic, and the infected, while terrifying,
			never overshadow the human drama. It's a testament to powerful storytelling, exploring themes
			of survival, found family, and hope in the darkest of times. A must-watch, even for those
			unfamiliar with the game.
		`,
	},
	{
		id: 673, // Example for 'Harry Potter and the Prisoner of Azkaban'
		mediaType: 'movie',
		title: 'Harry Potter and the Prisoner of Azkaban',
		rating: '4.8/5',
		reviewDate: '2022-11-01',
		poster_path: '/uZTtSgR8yWf223tHk6x9x0Q5Q0T.jpg',
		reviewText: `
			Alfonso Cuarón's take on "Prisoner of Azkaban" is a dark, visually stunning, and tonally distinct entry
			in the Harry Potter series. It marks a significant shift, embracing a more mature and atmospheric
			feel that perfectly captures the growing complexities of Harry's world. The cinematography is
			exceptional, using muted colors and dynamic camera work to create a sense of unease and wonder.

			The performances mature with the story, and the introduction of characters like Lupin and Sirius Black
			is handled brilliantly. The plot, involving time travel and mistaken identities, is intricate and
			engaging. This film truly elevated the series beyond a children's fantasy into a rich, fantastical
			drama. A personal favorite in the franchise.
		`,
	},
	{
		id: 671, // Example for 'Harry Potter and the Prisoner of Azkaban'
		mediaType: 'movie',
		title: 'Harry Potter and the Philosopher\'s Stone',
		rating: '4.8/5',
		reviewDate: '2022-11-01',
		poster_path: '/uZTtSgR8yWf223tHk6x9x0Q5Q0T.jpg',
		reviewText: `
			Test
		`,
	},
	// Add more of your personal reviews here!
];

export default reviews;